import React from 'react'

const Home = () => {
  return (
    <div className='background' style={{height: '100vh', width: '100%', overflow: 'hidden'}}>
        <iframe
        src="https://starhospitals.in/"
        title="External Website"
        style={{ border: 'none', height: '100%', width: '100%' }}
      ></iframe>
    </div>
  )
}

export default Home